<div class="container mb-5 mt-5">
  <div class="row g-4"> 
    <div *ngIf="displayedNews.length === 0" class="col-12 d-flex justify-content-center" style="color: gray; font-style: italic;">
      <h2 class="text-center my-5">Na žalost ni novic.</h2>
    </div>
    <div 
      class="col-12 col-sm-6 col-md-4 col-lg-3" 
      *ngFor="let news of displayedNews">
      
      <div class="news-card news-animated" (click)="openNewsModal(news)">
      <div class="news-image-container" >
        <img [src]="news.imageRef" alt="News Image" class="news-image">
      </div>
      <div class="news-content">
        <h2 class="news-title">{{ news.title }}</h2>
        <p class="news-summary">{{ limitedSummary(news.summary) }}</p>
        <a [routerLink]="['/organisation', news.organisationSlug]" class="news-author">
          {{ news.author }}
        </a>       
        <div class="d-flex justify-content-between align-items-center">
        <p class="news-date mb-0">{{ news.publishedAt | date: 'MMMM d, yyyy' }}</p>
        <a *ngIf="news.facebookLink" [href]="news.facebookLink" target="_blank" class="news-facebook-link">
          <fa-icon [icon]="faFacebook"></fa-icon>
        </a>
        </div>
        <button *ngIf="isSuperAdmin || isOrgAdmin" 
          (click)="deleteNews(news.newsID); $event.stopPropagation()" 
          class="btn btn-outline-danger w-100">
          <fa-icon class="me-2" [icon]="faTrash"></fa-icon>Izbriši
        </button>
        <button *ngIf="isSuperAdmin || isOrgAdmin"
          (click)="openEditNewsModal(news); $event.stopPropagation()" 
          class="btn btn-outline-primary w-100 mt-2">
          <fa-icon class="me-2" [icon]="faPen"></fa-icon>Uredi
        </button>
      </div>
      </div>
    </div>

    <!-- Add News Button -->
    <div class="col-12 d-flex justify-content-center">
      <button 
        *ngIf="isSuperAdmin || isOrgAdmin" 
        (click)="openAddNewsModal()" 
        class="btn button-74 add-news-button">
        <fa-icon class="me-3" [icon]="faPlus"></fa-icon>Nova novica
      </button>
    </div>
  </div>

  <!-- Load More Button -->
  <div *ngIf="showLoadMoreButton" class="d-flex justify-content-center mb-3 mt-3">
    <button class="btn button-74" (click)="revealMoreNews()">
      <fa-icon class="me-3" [icon]="faPlus"></fa-icon>Prikaži več
    </button>
  </div>
</div>
